const getRequiredData = (state, bookingRef) =>
  state.booking.required?.[bookingRef] ?? false;

export default getRequiredData;
